<script>/* eslint-disable */</script>
<template>
    <div>
      <h1>H1 Report</h1>
      <hr>
      <!-- FILTER START -->
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter Option</h4>
        </template>
        <div class="row outerBox filterBox">
            <div class="col row">
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <label for="dateTimeInput">From</label>
                  <flat-pickr
                    v-model="filter.start"
                    :config="seperatedRangeConfig"
                    placeholder="Select From Date"
                  />
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                  <label for="dateTimeInput">To</label>
                  <flat-pickr
                    v-model="filter.end"
                    :config="seperatedRangeConfig"
                    placeholder="Select To Date"
                  />
                </div>
                <div class="col-md-4 row" style="padding-top:26px">
                  <button class="btn btn-primary w-100" type="button" @click="search(0)">
                    <span class="fa fa-filter"></span>&nbsp;&nbsp;Search
                  </button>
                </div>
            </div>
        </div>
      </panel>
      <!-- FILTER END -->

      <b-card class="mb-4">
        <div class="row mb-3">
          <h4 class="col-md-2 col-sm-4 col-10 Aligner-Header ">
            H1 Details By Region
          </h4>
          <div class="col-md-1"></div>
          <div class="offset-md-7 col-md-2 col-sm-4 col-12 Aligner-Header">
            <button @click="search(1,'/h1-report/by-region')" class=" btn btn-success w-100" style="max-height:46px"><span class="fa fa-file-excel"/> Export</button>
          </div>
        </div>
        <div class="w-100"  v-if="by_region"  style="overflow-x:scroll">
          <table class="table text-center">
            <thead>
              <tr style="background-color:black;color:white">
                <th>Region Code</th>
                <th>Region Name</th>
                <th id="qr-registered-region">QR Registered</th>
                <th id="qr-replacement-region">QR Replacement</th>
                <th id="id-customer-region">ID Customer</th>
                <th id="id-customer-qr-region">ID Customer with QR</th>
                <th id="gr-md-region">GR MD</th>
                <th id="gi-md-region">GI MD</th>
                <th id="gr-d-region">GR Dealer</th>
                <th id="gi-d-region">GI Dealer</th>
              </tr>
            </thead>
            <tbody v-if="by_region">
              <tr v-for="(data, index) in by_region" :key="index">
                <td>{{data.code}}</td>
                <td>{{data.name}}</td>
                <td>{{numberWithCommas(data.qr_register)}}</td>
                <td>{{numberWithCommas(data.qr_replacement)}}</td>
                <td>{{numberWithCommas(data.id_cust)}}</td>
                <td>{{numberWithCommas(data.id_cust_with_qr)}}</td>
                <td>{{numberWithCommas(data.gr_md)}}</td>
                <td>{{numberWithCommas(data.gi_md)}}</td>
                <td>{{numberWithCommas(data.gr_dealer)}}</td>
                <td>{{numberWithCommas(data.gi_dealer)}}</td>
              </tr>
              <tr class="bg-grey">
                <th class="text-center" colspan="2">Total</th>
                <td>{{numberWithCommas(sumArray(by_region.map(x => x.qr_register)))}}</td>
                <td>{{numberWithCommas(sumArray(by_region.map(x => x.qr_replacement)))}}</td>
                <td>{{numberWithCommas(sumArray(by_region.map(x => x.id_cust)))}}</td>
                <td>{{numberWithCommas(sumArray(by_region.map(x => x.id_cust_with_qr)))}}</td>
                <td>{{numberWithCommas(sumArray(by_region.map(x => x.gr_md)))}}</td>
                <td>{{numberWithCommas(sumArray(by_region.map(x => x.gi_md)))}}</td>
                <td>{{numberWithCommas(sumArray(by_region.map(x => x.gr_dealer)))}}</td>
                <td>{{numberWithCommas(sumArray(by_region.map(x => x.gi_dealer)))}}</td>
              </tr>
          </tbody>
        </table>
        </div>
        
        <div class="text-center w-100" v-else>
          <h5>Loading.......</h5>
        </div>
      </b-card>

      <b-card class="mb-4">
        <div class="row mb-3">
          <h4 class="col-md-2 col-sm-4 col-12 Aligner-Header ">H1 Details By Dealer</h4>
          <div class="col-md-1"></div>
          <div class="offset-md-4 col-md-3 ">
            <Multiselect 
              v-model="filter.regionDealer"
              :options="options.mainDealer.map(type => type.code)"
              :custom-label="opt => options.mainDealer.find(x => x.code == opt).name"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :allow-empty="true"
              placeholder="All Main Dealer"
            />
          </div>
          <div class="col-md-2 col-sm-4 col-12 Aligner-Header">
            <button @click="search(1,'/h1-report/by-dealer')" class=" btn btn-success w-100" style="max-height:46px"><span class="fa fa-file-excel"/> Export</button>
          </div>
        </div>
        <div class="w-100"  v-if="by_region"  style="overflow-x:scroll">
          <table class="table text-center">
            <thead>
              <tr style="background-color:black;color:white">
                <th>Dealer Code</th>
                <th>Dealer Name</th>
                <th :id="header + '-dealer'" v-for="(header, index) in headerTitle" :key="header">
                  {{header}}
                </th>
              </tr>
            </thead>
            <tbody v-if="by_dealer">
              <tr class="bg-grey" >
                <th class="text-center" colspan="2">Total</th>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.qr_register)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.qr_replacement)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.id_cust)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.id_cust_with_qr)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.gr_md)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.gi_md)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.gr_dealer)))}}</td>
                <td>{{numberWithCommas(sumArray(by_dealer.map(x => x.gi_dealer)))}}</td>
              </tr>
              <tr v-for="(data, index) in showAllData ? by_dealer : by_dealer.length > 20 ? by_dealer.slice(0,20) : by_dealer" :key="index">
                <td>{{data.code}}</td>
                <td>{{data.name}}</td>
                <td>{{numberWithCommas(data.qr_register)}}</td>
                <td>{{numberWithCommas(data.qr_replacement)}}</td>
                <td>{{numberWithCommas(data.id_cust)}}</td>
                <td>{{numberWithCommas(data.id_cust_with_qr)}}</td>
                <td>{{numberWithCommas(data.gr_md)}}</td>
                <td>{{numberWithCommas(data.gi_md)}}</td>
                <td>{{numberWithCommas(data.gr_dealer)}}</td>
                <td>{{numberWithCommas(data.gi_dealer)}}</td>
              </tr>
              <tr v-if="by_dealer.length > 20">
                <td colspan="10">
                  <a v-if="!showAllData" class="clickAble" style="color:grey" @click="showAllData = true">Show All</a>
                  <a v-else class="clickAble" style="color:grey" @click="showAllData = false">Hide</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="text-center w-100" v-else>
            <h5>Loading.......</h5>
        </div>
      </b-card>

      <b-card>
        <div class="row mb-3 ">
          <h4 class="col-md-2 col-sm-4 col-12 Aligner-Header ">H1 Details By Month</h4>
          <div class="col-md-1"></div>
          <div class="offset-md-4 col-md-3 ">
            <Multiselect 
              v-model="filter.region"
              :options="options.mainDealer.map(type => type.code)"
              :custom-label="opt => options.mainDealer.find(x => x.code == opt).name"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :allow-empty="true"
              placeholder="All Main Dealer"
            />
          </div>
          <div class="col-md-2 col-sm-4 col-12 Aligner-Header">
            <button @click="search(1,'/h1-report/by-month')" class=" btn btn-success w-100" style="max-height:46px"><span class="fa fa-file-excel"/> Export</button>
          </div>
        </div>
        
        <div class="w-100"  v-if="by_month"  style="overflow-x:scroll">
          <table class="table text-center">
            <thead>
              <tr style="background-color:black;color:white">
                <th>Month</th>
                <th>Year</th>
                <th id="qr-registered-month">QR Registered</th>
                <th id="qr-replacement-month">QR Replacement</th>
                <th id="id-customer-month">ID Customer</th>
                <th id="id-customer-qr-month">ID Customer with QR</th>
                <th id="gr-md-month">GR MD</th>
                <th id="gi-md-month">GI MD</th>
                <th id="gr-d-month">GR Dealer</th>
                <th id="gi-d-month">GI Dealer</th>
                <th>Options</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in by_month" :key="index">
                <td>{{data.bulan}}</td>
                <td>{{data.tahun}}</td>
                <td>{{numberWithCommas(data.qr_register)}}</td>
                <td>{{numberWithCommas(data.qr_replacement)}}</td>
                <td>{{numberWithCommas(data.id_cust)}}</td>
                <td>{{numberWithCommas(data.id_cust_with_qr)}}</td>
                <td>{{numberWithCommas(data.gr_md)}}</td>
                <td>{{numberWithCommas(data.gi_md)}}</td>
                <td>{{numberWithCommas(data.gr_dealer)}}</td>
                <td>{{numberWithCommas(data.gi_dealer)}}</td>
                <td><button class="btn btn-primary w-100" @click="getMonthDetail(data.bulan , data.tahun)">Details</button></td>
              </tr>
              <tr class="bg-grey">
                <th class="text-center" colspan="2">Total</th>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.qr_register)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.qr_replacement)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.id_cust)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.id_cust_with_qr)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.gr_md)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.gi_md)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.gr_dealer)))}}</td>
                <td>{{numberWithCommas(sumArray(by_month.map(x => x.gi_dealer)))}}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="text-center w-100" v-else>
          <h5>Loading.......</h5>
        </div>
      </b-card>

      <detailModal v-on:closeModal="showModal = false" v-if="showModal" :data="summaryData" :period="period"></detailModal>
    </div>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Multiselect  from 'vue-multiselect'
import { options } from '@amcharts/amcharts4/core'
import flatPickr from 'vue-flatpickr-component'

import detailModal from './children/detailModal'

export default {
	components: {
        Datepicker,
        Multiselect,
        detailModal,
        flatPickr,
    },
    data () {
      const startOfMonth = moment().startOf('year').toDate();
      const endOfMonth   = moment().toDate();
      return {
        seperatedRangeConfig: {
          altInput: true,
          altInputClass: 'form-control input flatpickr-input',
          animate: !this.isRTL(),
        },
        showAllData : false,
        options : this.$store.getters.getFilterOptions,
        filterData: null,
        filter: {
          start: startOfMonth, 
          end: endOfMonth,
          region: [],
          regionDealer: []
          // branch: []
        },
        by_month: [],
        by_region: [],
        by_dealer: [],
        showModal: false,
        summaryData: null,
        headerTitle : ['QR Registered', 'QR Replacement' , 'ID Customer' , 'ID Custiomer With QR' , 'GR MD' , 'GI MD' , 'GR Dealer' , 'GI Dealer']
      }
    },
    mounted () {
        this.loadFilter()
        this.search(0, null)
    },
    watch: {
      'filter.region' : function () {
        this.search(0 , ['/h1-report/by-month'])
      },
      'filter.regionDealer' : function () {
        this.search(0 , ['/h1-report/by-dealer'])
      }
    },
    methods: {
        sumArray(data) {
          let total = 0

          for(var i = 0;  i < data.length ; i++) {
            total += parseInt(data[i])
          }
          return total
        },
        async getMonthDetail (month , year) {
            let date = moment(`01 ${month} ${year}`)

            let filter = {
                region : this.filter.region,
                month : date.month() + 1,
                year : date.year()
            }

            filter = await this.transformFilter(filter)
            filter = await this.initializeFilter(filter)

            let url = "/api/reports/h1-report/daily-detail"
 
            this.$http.get(url + filter)
            .then((resp) => {
                this.summaryData = resp.data.data
                this.showModal = true
                this.period = filter
            })
            .catch((err) => {
                console.log(err)
            })


        },
        loadFilter (type) {
            if (type == 'region'){
                this.filter.branch.length = 0;
                this.filterData.branch = this.$store.getters.getBranch(this.filter.region)
            } else if (type == 'segment'){
                // this.filter.series.length = 0;
                this.filterData.series = this.$store.getters.getSeries(this.filter.segment)

                this.filter.type.length = 0;
                this.filterData.type = this.$store.getters.getType(this.filter.segment, this.filter.series)
            } else if (type == 'series'){
                this.filter.type.length = 0;
                this.filterData.type = this.$store.getters.getType(this.filter.segment, this.filter.series)
            } else {
                this.filterData = this.$store.getters.getFilterOptions
            } 
        },
        async search (flag, url) {
            
            let filter = Object.assign({} , this.filter)
            if(url == null) url = ['/h1-report/by-month', '/h1-report/by-region', '/h1-report/by-dealer']
            
            if(flag == 1) {
                this.downloadExcel(filter, url)
                return;
            }

            this.loadAPI(filter, url)

        },
        async downloadExcel (filter , url) {
            let variable = url.split('/')[2].split('-').join(' ')

            if(variable == 'by region') delete filter.region

            filter = await this.transformFilter(filter)
            filter = await this.initializeFilter(filter)
            filter += '&exportExcel=1'
            
            this.$http.get('/api/reports' + url + filter , {responseType : 'blob'})
            .then((resp)=>{
                const blob = new Blob([resp.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = "H1 report " +  variable;
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        async loadAPI(filter, url) {
            

            for (var i = 0 ; i < url.length ; i++) {
                let obj = Object.assign({} , filter)

                let variable = url[i].split('/')[2].split('-').join('_')

                this[variable] = null;

                if(variable == 'by_region') delete obj.region 
                else if(variable == 'by_dealer') {
                  obj.region = obj.regionDealer
                  delete obj.regionDealer
                }
                else {
                  delete obj.regionDealer
                }

                obj = await this.transformFilter(obj)
                obj = await this.initializeFilter(obj)


                this.$http.get('/api/reports' + url[i] + obj)
                .then((resp) => {
                    var data = resp.data.data;
                    console.log(data , variable)
                    this[variable] = data
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        },
        async initializeFilter (filters) {
            let filterUrl = '?'
            let keys = Object.keys(filters)
            for (var i = 0; i < keys.length; i++) {
              if(filters[keys[i]] && typeof filters[keys[i]] == 'object' && filters[keys[i]].length > 0)
                filterUrl += `${keys[i]}=${filters[keys[i]]}&`
              else if( filters[keys[i]] != null && filters[keys[i]] != ''){
                filterUrl += `${keys[i]}=${filters[keys[i]]}&`
              }
            }
            
            return filterUrl
        },
        async transformFilter (filter) {
            let obj = {}
            let keys = Object.keys(filter)
            for (var i = 0 ; i < keys.length; i++) {
              if(keys[i] == 'start' || keys[i] == 'end')  {
                obj[keys[i]] = moment(filter[keys[i]]).format("YYYY-MM-DD")
              }
              else {
                obj[keys[i]] = filter[keys[i]]
              }
            }
            return obj
        },
        customFormatter : function(date){
			return moment(date).format('Y-MM-DD');
		},
        numberWithCommas(x) {
        return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
}
</script>

<style scoped>
  td .btn {
    line-height: 1;
  }

  .Aligner-Header {
    padding-left:3% !important;
    color: #707070;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .clickAble:hover {
    text-decoration: underline;
    cursor: pointer;
  }
</style>